import React, {  useRef, useState } from 'react'
import * as THREE from "three";
import { Canvas } from '@react-three/fiber'
// import { Leva } from 'leva'
import "./CrystalScene.scss"; // Import the CSS file
import Scene from './Scene';
// import crystalTexture from "../../assets/3d/crystal-texture.jpg"; // Import the texture

function CrystalScene() {
	const containerRef = useRef(null);
	const mouseX = useRef(0);
	const mouseY = useRef(0);
	const [isDesktop, setIsDesktop] = useState(true);



	return (
    <div id="crystal-container-wrapper">
      <div className="inner-container">
        <div
          id="crystal-container"
          ref={containerRef}
        >
          <Canvas
            shadows
            dpr={[1, 2]}
            className="r3f"
          >
			<Scene />
			
          </Canvas>
        </div>
      </div>
    </div>
  )
}

export default CrystalScene;






// import React, { useEffect, useRef, useState } from "react";
// import * as THREE from "three";
// import { OBJLoader } from "three/examples/jsm/loaders/OBJLoader";

// import "./CrystalScene.scss"; // Import the CSS file

// import crystalModel from "../../assets/3d/crystal.obj"; // Import the 3D model
// import crystalTexture from "../../assets/3d/crystal-texture.jpg"; // Import the texture

// function CrystalScene() {
// 	const containerRef = useRef(null);
// 	const mouseX = useRef(0);
// 	const mouseY = useRef(0);
// 	const [isDesktop, setIsDesktop] = useState(true);

// 	useEffect(() => {
// 		// Device detection
// 		const checkDevice = () => {
// 			setIsDesktop(
// 				!("ontouchstart" in window) &&
// 					!navigator.maxTouchPoints &&
// 					!navigator.msMaxTouchPoints
// 			);
// 		};

// 		checkDevice();

// 		// --- Three.js Setup ---
// 		const scene = new THREE.Scene();
// 		scene.background = null;

// 		const container = containerRef.current;
// 		const camera = new THREE.PerspectiveCamera(
// 			75,
// 			container.offsetWidth / container.offsetHeight,
// 			0.1,
// 			1000
// 		);
// 		const renderer = new THREE.WebGLRenderer({
// 			antialias: true,
// 			alpha: true,
// 		});
// 		renderer.setSize(container.offsetWidth, container.offsetHeight);
// 		renderer.toneMapping = THREE.ACESFilmicToneMapping;
// 		renderer.setClearColor(0x000000, 0);
// 		renderer.shadowMap.enabled = true;
// 		renderer.shadowMap.type = THREE.PCFSoftShadowMap;
// 		renderer.setPixelRatio( window.devicePixelRatio );

// 		container.appendChild(renderer.domElement);

// 		// --- Ground plane ---
// 		const planeGeometry = new THREE.PlaneGeometry(5, 5);
// 		const planeMaterial = new THREE.MeshStandardMaterial({
// 			color: 0x999999,
// 			metalness: 1,
// 			roughness: 1,
// 			emissive: new THREE.Color(0x181818),
// 			emissiveIntensity: 1,
// 		});

// 		const plane = new THREE.Mesh(planeGeometry, planeMaterial);
// 		plane.rotation.x = -Math.PI / 2;
// 		plane.position.y = -1;

// 		plane.receiveShadow = true;

// 		scene.add(plane);

// 		// --- Lighting ---
// 		const ambientLight = new THREE.AmbientLight(0x707070);
// 		scene.add(ambientLight);

// 		const spotLight = new THREE.SpotLight(0x3a1c4d, 60);
// 		spotLight.position.set(0.2, 2, 0.1);
// 		spotLight.target.position.set(0, 0, 0);
// 		spotLight.angle = Math.PI / 7;
// 		spotLight.penumbra = 1;
// 		spotLight.decay = 0;
// 		spotLight.distance = 9;

// 		spotLight.castShadow = true;
// 		spotLight.shadow.mapSize.width = 1024;
// 		spotLight.shadow.mapSize.height = 1024;
// 		spotLight.shadow.camera.near = 0.5;
// 		spotLight.shadow.camera.far = 10;

// 		scene.add(spotLight);
// 		scene.add(spotLight.target);

// 		const spotLight2 = new THREE.SpotLight(0x191335, 60);
// 		spotLight2.position.set(-0.2, 2, 0.1);
// 		spotLight2.target.position.set(0, 0, 0);
// 		spotLight2.angle = Math.PI / 7;
// 		spotLight2.penumbra = 1;
// 		spotLight2.decay = 0;
// 		spotLight2.distance = 9;

// 		spotLight2.castShadow = true;
// 		spotLight2.shadow.mapSize.width = 1024;
// 		spotLight2.shadow.mapSize.height = 1024;
// 		spotLight2.shadow.camera.near = 0.5;
// 		spotLight2.shadow.camera.far = 10;

// 		scene.add(spotLight2);
// 		scene.add(spotLight2.target);

// 		// pink spotlight
// 		const spotLight3 = new THREE.SpotLight(0xd48ee5, 10);
// 		spotLight3.position.set(0, 2, 3);
// 		spotLight3.target.position.set(0, 1.9, 0);
// 		spotLight3.angle = Math.PI / 6;
// 		spotLight3.penumbra = 1;
// 		spotLight3.decay = 0;
// 		spotLight3.distance = 9;

// 		scene.add(spotLight3);
// 		scene.add(spotLight3.target);

// 		const directionalLight = new THREE.DirectionalLight(0x3f4c63, 7);
// 		directionalLight.position.set(0, -1, 1);
// 		scene.add(directionalLight);

// 		// --- Crystal Material & Texture ---
// 		const textureLoader = new THREE.TextureLoader();
// 		const texture = textureLoader.load(crystalTexture);

// 		const crystalMaterial = new THREE.MeshPhysicalMaterial({
// 			metalness: 0.2,
// 			roughness: 0.1,
// 			transmission: 0.7,
// 			opacity: 0.9,
// 			depthWrite: true,
// 			ior: 2.4,
// 			thickness: 2,
// 			side: THREE.DoubleSide,
// 			map: texture,
// 			transparent: true,
// 			emissive: new THREE.Color(0x3a1c4d),
// 			emissiveIntensity: 0.2,
// 		});

// 		// --- Load Crystal ---
// 		let crystal;
// 		const objLoader = new OBJLoader();
// 		objLoader.load(
// 			crystalModel,
// 			(object) => {
// 				object.traverse((child) => {
// 					if (child.isMesh) {
// 						child.material = crystalMaterial;
// 						child.castShadow = true;
// 						child.receiveShadow = true;
// 					}
// 				});

// 				const box = new THREE.Box3().setFromObject(object);
// 				const center = box.getCenter(new THREE.Vector3());
// 				object.position.sub(center);
// 				const size = box.getSize(new THREE.Vector3());
// 				const maxDim = Math.max(size.x, size.y, size.z);
// 				const scale = 2.8 / maxDim;
// 				object.scale.set(scale, scale, scale);

// 				crystal = object;
// 				crystal.rotation.y = -Math.PI / 2 - 0.2;
// 				scene.add(object);

// 				crystal.position.y = 0.3;

// 				handleResize();
// 				animate();
// 			},
// 			(xhr) => {
// 				console.log((xhr.loaded / xhr.total) * 100 + "% loaded");
// 			},
// 			(error) => {
// 				console.error("Error loading OBJ:", error);
// 			}
// 		);

// 		// --- Interaction Handlers ---
// 		const mouseMoveHandler = (event) => {
// 			mouseX.current = (event.clientX / window.innerWidth) * 2 - 1;
// 			mouseY.current = -(event.clientY / window.innerHeight) * 2 + 1;
// 		};

// 		const scrollHandler = () => {
// 			const scrollMax = 300;
// 			const currentScroll = Math.min(window.scrollY, scrollMax);
// 			// Convert scroll position to -1 to 1 range
// 			mouseX.current = (currentScroll / scrollMax) * 2 - 1;
// 			mouseY.current = 0; // Keep Y position fixed for mobile scroll
// 		};

// 		// Add appropriate event listener based on device type
// 		if (isDesktop) {
// 			window.addEventListener("mousemove", mouseMoveHandler);
// 		} else {
// 			window.addEventListener("scroll", scrollHandler);
// 		}

// 		// --- Animation Loop ---
// 		const animate = function () {
// 			const closerRadius = 2.6;
// 			camera.position.x =
// 			closerRadius * Math.sin(-mouseX.current * Math.PI * 0.2);
// 			camera.position.z =
// 			closerRadius * Math.cos(-mouseX.current * Math.PI * 0.2);
// 			camera.position.y = 0;
			
// 			camera.lookAt(0, 0, 0);
// 			renderer.render(scene, camera);

// 			requestAnimationFrame(animate);
// 		};

// 		// --- Resize Handler ---
// 		function handleResize() {
// 			const containerWidth = container.offsetWidth;
// 			const containerHeight = container.offsetHeight;
// 			camera.aspect = containerWidth / containerHeight;
// 			camera.updateProjectionMatrix();
// 			renderer.setSize(containerWidth, containerHeight);
// 		}

// 		window.addEventListener("resize", handleResize);

// 		// --- Cleanup ---
// 		return () => {
// 			window.removeEventListener("resize", handleResize);
// 			window.removeEventListener("resize", checkDevice);
// 			if (isDesktop) {
// 				window.removeEventListener("mousemove", mouseMoveHandler);
// 			} else {
// 				window.removeEventListener("scroll", scrollHandler);
// 			}
// 			container.removeChild(renderer.domElement);
// 		};
// 	}, [isDesktop]);

// 	return (
// 		<div id="crystal-container-wrapper">
// 			<div className="inner-container">
// 				<div id="crystal-container" ref={containerRef} />
// 			</div>
// 		</div>
// 	);
// }

// export default CrystalScene;
